/* eslint-disable */
import { Route, BrowserRouter as BaseRoutes, Switch } from "react-router-dom";
import { useStores } from "./use.store";
import Splashscreen from "./pages/Splashscreen";
import { observer } from "mobx-react-lite";
import React from "react";
import Home from "./pages/Home";
import GetInfo from "./pages/GetInfo";
import GetInfoDetail from "./pages/GetInfoDetail";

const Routes = observer(() => {
  const { generalStore } = useStores();
  return generalStore.loading ? (
    <Splashscreen />
  ) : (
    <BaseRoutes>
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/wayfinder" exact component={Home} />
        <Route path="/get-info" exact component={GetInfo} />
        <Route path="/get-info/:id" component={GetInfoDetail} />
        <Route component={Home} />
      </Switch>
    </BaseRoutes>
  );
});

export default Routes;
